// extracted by mini-css-extract-plugin
module.exports = {"container":"subjects_container__2wMoB","subjectName":"subjects_subjectName__mK-hs"};